/**
 * Split pane for UCAT Verbal Reasoning items with non-empty exhibit_text,
 * and for UCAT most/least groups on a compact (phone) viewport only.
 * Never the leftover pearson always-split Passage pane. Never Yes/No.
 */
export function isUcatPearsonYesNoGroup(question) {
  return Boolean(
    question
    && question.interaction_kind === 'yes_no_group'
    && Array.isArray(question.yes_no_items)
    && question.yes_no_items.length > 0
  );
}

export function isUcatPearsonMostLeastGroup(question) {
  return Boolean(
    question
    && question.interaction_kind === 'most_least_group'
    && Array.isArray(question.most_least_options)
    && question.most_least_options.length > 0
  );
}

export function shouldSplitUcatPearsonItem(examName, question, moduleKey, options = {}) {
  if (String(examName || '').toUpperCase() !== 'UCAT') return false;
  if (isUcatPearsonYesNoGroup(question)) return false;
  if (isUcatPearsonMostLeastGroup(question)) {
    return Boolean(options.compactViewport);
  }
  if (moduleKey !== 'verbal_reasoning') return false;
  return String(question?.exhibit_text || '').trim().length > 0;
}

export function usesLeftoverPearsonLayout(examMode, pearsonPlayer) {
  return examMode === 'pearson' && !pearsonPlayer;
}
